import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { ConcentreRow } from 'src/modules/motor-credito/serasa/serasa.pf.types'

const concentreColumns = static_build_participacao_societaria_columns()

export type ConcentreProps = {
    concentreRows: ConcentreRow[]
}

export default function Concentre({ concentreRows }: ConcentreProps) {
    if (concentreRows && concentreRows.length) {
        return (
            <>
                <Divider textAlign="center">Dados Concentre</Divider>

                <Grid
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    <Grid size={12}>
                        <DataGrid
                            rows={concentreRows || []}
                            columns={concentreColumns}
                            getRowId={static_getRowId}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10
                                    }
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }
    return <></>
}

function static_getRowId(row: ConcentreRow) {
    return row.periodo + row.quantidade + row.discriminacao + row.ocorrencia_mais_recente
}

function static_build_participacao_societaria_columns(): GridColDef[] {
    return [
        {
            field: 'quantidade',
            headerName: 'Quantidade',
            width: 100
        },
        {
            field: 'discriminacao',
            headerName: 'Discriminação',
            width: 300
        },
        {
            field: 'periodo',
            headerName: 'Período',
            width: 100
        },
        {
            field: 'ocorrencia_mais_recente',
            headerName: 'Ocorrência mais rececente',
            width: 200
        }
    ]
}
